import { StyledTypography } from './styled';

type PropsType = {
  path: string;
  label: string;
  onClick?: () => void;
};

const ExternalLink = ({ path, label, onClick }: PropsType) => (
  <StyledTypography as="a" href={path} onClick={onClick}>
    {label}
  </StyledTypography>
);

export default ExternalLink;
